// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1m1wW","title":"BackImages_title__jtKPq","images":"BackImages_images__2Ma1D"};